"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "sermoneta": {
    "0da2a550": [{
      "hkey": "d50ac2b0",
      "slug": "sermoneta",
      "name": "Sermoneta",
      "primary": true,
      "skipSearch": false
    }],
    "carlacupa": [{
      "hkey": "d50ac2b0",
      "slug": "sermoneta",
      "name": "Sermoneta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4588d396": [{
      "hkey": "e9db9de0",
      "slug": "carrara-pontenuovo",
      "name": "Carrara-Pontenuovo",
      "primary": true,
      "skipSearch": false
    }],
    "carrara": [{
      "hkey": "e9db9de0",
      "slug": "carrara-pontenuovo",
      "name": "Carrara-Pontenuovo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;